// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2Km4m","col":"styles_col__2xm7R"};